import { PermissionsEnum } from "@/auth/interfaces";
import { useCheckPermissions } from "@/shared";
import { fetchGetByIdPreventasCorporativos } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom";
import AddMaterialFactibilidadCorporativoPage from "../../shared/add_solicitud_factibilidad_corporativo/AddMaterialFactibilidadCorporativoPage";

export default function AprobarSolicitudVentaCorporativoPage() {
  useCheckPermissions(PermissionsEnum.api_change_factibilidadcoorporativa);

  const { idpreventacorporativa } = useParams();

  const {
    data: dataPreventaCorporativa,
    isLoading: isLoadingPreventaCorporativa,
  } = fetchGetByIdPreventasCorporativos(idpreventacorporativa!);

  if (isLoadingPreventaCorporativa) return <LoaderComponent />;

  if (!dataPreventaCorporativa) return null;

  return (
    <AddMaterialFactibilidadCorporativoPage
      title="Pre-Factibilidad Corporativa"
      dataPreventa={dataPreventaCorporativa.data!}
      updateFactibilidad={true}
      showSaveButton={false}
    />
  );
}
